import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@app/guards/auth.guard';
import { RedirectGuard } from '@app/guards/redirect.guard';
import { CurrentContextResolver } from '@app/context-resolver/context-resolver';
import { HubHomeComponent } from './hub-home/hub-home.component';
import { ProgramListComponent } from './program-list/program-list.component';
import { ProgramHomeComponent } from './program-home/program-home.component';
import { SimulationEditComponent } from './simulation-edit/simulation-edit.component';

// Note that these routes are the same as for Spaces.
// They are only reached if the hub is a program hub because the routes in WondaModule take priority.
const routes: Routes = [
  {
    path: ':urlTitle',
    component: HubHomeComponent,
    resolve: { context: CurrentContextResolver },
    canActivate: [AuthGuard, RedirectGuard],
    data: { noIndex: true }
  },
  {
    path: ':urlTitle/contribute',
    component: ProgramListComponent,
    resolve: { context: CurrentContextResolver },
    canActivate: [AuthGuard, RedirectGuard],
    data: { noIndex: true }
  },
  {
    path: ':urlTitle/:lsId',
    component: ProgramHomeComponent,
    resolve: { context: CurrentContextResolver },
    canActivate: [AuthGuard, RedirectGuard]
  },
  {
    path: ':urlTitle/:lsId/simulations/:courseId',
    component: SimulationEditComponent,
    resolve: { context: CurrentContextResolver },
    canActivate: [AuthGuard, RedirectGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProgramRoutingModule { }
